export default __webpack_public_path__ + "static/media/SG-White-0004.fb24c909.png";